<div class="mt-2">
  <mat-accordion id="RuleDetails">
    <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
      <mat-expansion-panel-header class="ia-mat-panel">
        <mat-panel-title>
          <span class="text-header inc-f"> Key Information Summary</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row rule_owner_row ml-2 mt-1">
        <div class="col-lg-2 mb-3">
          <label class="control-label fw">Rule Owner</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.ruleOwner }}
          </div>
        </div>

        <div class="col-lg-2 mb-3">
          <label class="control-label fw">Compliance Status</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.complianceStatus }}
          </div>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="control-label fw">Assessment Date</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.assessmentDate | date : "dd-MM-yyyy" }}
          </div>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="control-label fw">Review Date</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.reviewDate | date : "dd-MM-yyyy" }}
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="control-label fw">Assessment Status</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.assessmentStatus }}
          </div>
        </div>
      </div>
      <div class="row rule_owner_row ml-2 mt-4">
        <div class="col-lg-2 mb-3">
          <label class="control-label fw">LBG Impact</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.lbgImpact ? "Yes" : "No" }}
          </div>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="control-label fw">RFB Impact</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.rfbImpact ? "Yes" : "No" }}
          </div>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="control-label fw">LBCM Impact</label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.lbcmImpact ? "Yes" : "No" }}
          </div>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="control-label fw"> Next Assessment Due </label>
          <div class="pt-2 control-label control-input">
            {{ keyInformation.nextAssessmentDueDate | date : "dd-MM-yyyy" }}
          </div>
        </div>
      </div>
      <div>
        <app-progress-bar [isLoading]="isLoadingSummaryData"></app-progress-bar>
        <div
          class="table-responsive scheduler_table_main add_row_2 box-shadow table-cont"
          [style.max-height.px]="myInnerHeight"
        >
          <table
            class="table scheduler_table rules-connection-table table-hover mb-0"
          >
            <thead>
              <tr>
                <th style="width: 150px">Category</th>
                <th style="width: 100px">Ref Id</th>
                <th style="width: 100px">Title</th>
                <th style="width: 100px">Topic</th>
                <th style="width: 150px">Review Status</th>
                <th style="width: 100px">Approval Status</th>
                <th style="width: 100px">Approval Date</th>
                <th style="width: 120px">Next Approval Due</th>
                <th style="width: 150px">LBG Materiality</th>
                <th style="width: 150px">RFB Materiality</th>
                <th style="width: 150px">LBCM Materiality</th>
              </tr>
            </thead>
            <tbody
              *ngIf="summaryDetailsData && summaryDetailsData.length === 0"
            >
              <tr>
                <td colspan="6">No Data</td>
              </tr>
            </tbody>
            <tbody #tableBody>
              <tr *ngFor="let item of summaryDetailsData; let i = index">
                <td style="width: 150px">{{ item.type }}</td>
                <td style="width: 100px">
                  <span class="fixed_height">{{ item.referenceNumber }}</span>
                </td>
                <td style="width: 100px">
                  <span class="fixed_height">{{ item.title }}</span>
                </td>
                <td style="width: 100px">
                  <span class="fixed_height">{{ item.topic }}</span>
                </td>
                <td style="width: 150px">
                  <mat-chip-row
                    [selectable]="selectable"
                    [ngStyle]="{ 'background-color': item.reviewClassStyle }"
                    *ngIf="item.reviewStatus"
                  >
                    <lucide-icon
                      *ngIf="item.reviewIcon != ''"
                      [name]="item.reviewIcon"
                      size="14"
                    ></lucide-icon>
                    {{ item.reviewStatus }}
                  </mat-chip-row>
                </td>
                <td style="width: 100px">
                  <span class="fixed_height">{{ item | approvalStatus }}</span>
                </td>
                <td style="width: 100px">
                  <span class="fixed_height">{{
                    item.approverDate | date : "dd-MMM-yyyy"
                  }}</span>
                </td>
                <td style="width: 120px">
                  {{ item.nextApprovalDue | date : "dd-MMM-yyyy" }}
                </td>
                <td style="width: 150px">
                  <mat-chip-row
                    [selectable]="selectable"
                    [ngStyle]="{ 'background-color': item.lbgClassStyle }"
                    *ngIf="item.lbgMateriality"
                  >
                    <lucide-icon
                      *ngIf="item.lbgIcon != ''"
                      [name]="item.lbgIcon"
                      size="14"
                    ></lucide-icon>
                    {{ item.lbgMateriality }}
                  </mat-chip-row>
                </td>
                <td style="width: 150px">
                  <mat-chip-row
                    [selectable]="selectable"
                    [ngStyle]="{ 'background-color': item.rfbClassStyle }"
                    *ngIf="item.rfbMateriality"
                  >
                    <lucide-icon
                      *ngIf="item.rfbIcon != ''"
                      [name]="item.rfbIcon"
                      size="14"
                    ></lucide-icon>
                    {{ item.rfbMateriality }}
                  </mat-chip-row>
                </td>
                <td style="width: 150px">
                  <mat-chip-row
                    [selectable]="selectable"
                    [ngStyle]="{ 'background-color': item.lbcmClassStyle }"
                    *ngIf="item.lbcmMateriality"
                  >
                    <lucide-icon
                      *ngIf="item.lbcmIcon != ''"
                      [name]="item.lbcmIcon"
                      size="14"
                    ></lucide-icon>
                    {{ item.lbcmMateriality }}
                  </mat-chip-row>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
